import { createContext } from 'react';

export const DraggableListContext = createContext<{ dragPortal: React.RefObject<HTMLDivElement> } | null>(null);
